import Vue from 'vue'
import Router from 'vue-router'
import ViedeoPlay from '@/content/play'
import Login from '@/content/login'
import AiLogin from '@/content/aiLogin'
import Content from '@/content/content'
import NoVideoMobile from '@/content/noVideoMobile'
import NoVideoPc from '@/content/noVideoPc'
import toolkit from '@/util/toolkit'
import config from "@/util/config"
import ExamRoutes from "@/content/exam/router.js"
import AiExamRoutes from "@/content/ai-exam/router.js"
import GroupInterviewRoutes from "@/content/group-interview/router.js"
Vue.use(Router)

const router = new Router({
  mode: config.routerMode,
  routes: [
    {
      path: '/interview-replay',
      name: 'interview-replay',
      component: ()=>import("@/content/interviewReplay.vue")
    },
    {
      path: '/app/editor',
      name: 'oteditor',
      component: ()=>import("@/content/ot.vue")
    },{
      path: '/play',
      name: 'play',
      meta: {
        needToken: false,
      },
      component: ViedeoPlay
    },{
      path: '/',
      name: 'index',
      meta: {
        needToken: false
      },
      component: Login
    },{
      path: '/login',
      name: 'login',
      meta: {
        needToken: false
      },
      component: Login
    },{
      path: '/ai-login',
      name: 'ai-login',
      meta: {
        needToken: false
      },
      component: AiLogin
    },{
      path: '/create-company',
      name: 'create-company',
      meta: {
        needToken: true,
        needCompany: false
      },
      component: ()=>import("@/content/create-company.vue")
    },{
      path: '/content',
      name: 'content',
      meta: {
        needToken: true,
        needCompany: true,
      },
      component: Content
    },{
      path: '/no-video-mobile',
      name: 'no-video-mobile',
      meta: {
        needToken: false
      },
      component: NoVideoMobile
    },{
      path: '/no-video-pc',
      name: 'no-video-pc',
      meta: {
        needToken: false
      },
      component: NoVideoPc
    },{
      path: '/rtc-video',
      name: 'rtc-video',
      meta: {
        needToken: false,
        checkUa: true
      },
      component: (resolve) => require(['@/content/video/multi'], resolve)
    },{
      path: '/multi-video',
      name: 'multi-video',
      meta: {
        needToken: false,
        checkUa: true
      },
      component: (resolve) => require(['@/content/video/multi'], resolve)
    },
    {
      path: "/video",
      redirect: "/app/video"
    },
    {
      path: '/app/video',
      name: 'wait-video',
      meta: {
        needToken: false,
        checkUa: true
      },
      component: (resolve) => require(['@/content/video/middle'], resolve)
    },{
      path: '/device-test',
      name: 'device-test',
      meta: {
        needToken: false,
        checkUa: true
      },
      component: (resolve) => require(['@/content/video/test'], resolve)
    },{
      path: '/browser',
      name: 'browser',
      meta: {
        needToken: false
      },
      component: (resolve) => require(['@/content/browserTest'], resolve)
    },{
      path: '/schema',
      name: 'schema',
      meta: {
        needToken: false
      },
      component: (resolve) => require(['@/content/schema'], resolve)
    },{
      path: '/guide',
      name: 'guide',
      meta: {
        needToken: false
      },
      component: (resolve) => require(['@/content/guide'], resolve)
    },{
      path: '/only-pc',
      name: 'only-pc',
      meta: {
        needToken: false
      },
      component: (resolve) => require(['@/content/onlyPc'], resolve)
    },{
      path: '/only-wechat',
      name: 'only-wechat',
      meta: {
        needToken: false
      },
      component: (resolve) => require(['@/content/onlyWechat'], resolve)
    },{
      path: '/queue-manager',
      name: 'queue-manager',
      meta: {
        needToken: false
      },
      component: (resolve) => require(['@/content/queue/queue-layout'], resolve)
    },{
      path: '/create-queue',
      name: 'create-queue',
      meta: {
        needToken: true,
        needCompany: true
      },
      component: (resolve) => require(['@/content/queue/create-queue'], resolve)
    },
    {
      path: "/queue",
      redirect: "/app/queue"
    },
    {
      path: '/app/queue',
      name: 'queue',
      meta: {
        needToken: false
      },
      component: (resolve) => require(['@/content/queue/queue-old'], resolve)
    },{
      path: '/queue-status',
      name: 'queue-status',
      meta: {
        needToken: false
      },
      component: (resolve) => require(['@/content/queue/queue-status'], resolve)
    },
    // 空中宣讲(分清管理页和展示页)
    {
      path: '/kxlist',
      name: 'kxlist',
      meta: {
        needCompany: true,
        needToken: true,
      },
      component: (resolve) => require(['@/content/kongxuan/list'], resolve)
    },
    {
      path: "/kx",
      redirect: "/app/kx"
    },
    {
      path: '/app/kx',
      name: 'kx',
      meta: {
        needToken: false,
        nocheckUa: true
      },
      component: (resolve) => require(['@/content/kongxuan/kx'], resolve)
    },
    {
      path: '/kx-guide',
      name: 'kx-guide',
      meta: {
        needToken: false
      },
      component: (resolve) => require(['@/content/kongxuan/guide'], resolve)
    },
    {
      path: '/video-storage',
      name: 'video-storage',
      meta: {
        needCompany: true,
        needToken: true,
      },
      component: (resolve) => require(['@/content/kongxuan/video-storage'], resolve)
    },
    {
      path: '/statistic',
      name: 'statistic',
      meta: {
        needCompany: true,
        needToken: true,
      },
      component: (resolve) => require(['@/content/kongxuan/statistic'], resolve)
    },
    {
      path: '/position-list',
      name: 'position-list',
      meta: {
        needCompany: true,
        needToken: true,
      },
      component: (resolve) => require(['@/content/kongxuan/position-list'], resolve)
    },
    {
      path: '/post-position',
      name: 'post-position',
      meta: {
        needCompany: false,
        needToken: false,
      },
      component: (resolve) => require(['@/content/kongxuan/post-position'], resolve)
    },{
      path: '/kx-deny',
      name: 'kx-deny',
      component: (resolve) => require(['@/content/kongxuan/kxDeny'], resolve)
    },
    // 在线笔试模块
    ...ExamRoutes,
    // AI面试官网跳转
    ...AiExamRoutes,
    // ai面试
    {
      path: '/ailist',
      name: 'ailist',
      meta: {
        needCompany: true,
        needToken: true,
        keepAlive: true,
      },
      component: (resolve) => require(['@/content/ai/list'], resolve)
    },
    {
      path: '/aicreate',
      name: 'aicreate',
      meta: {
        needCompany: true,
        needToken: true,
      },
      component: (resolve) => require(['@/content/ai/create'], resolve)
    },{
      path: '/aicandidate',
      name: 'aicandidate',
      meta: {
        needCompany: true,
        needToken: true,
      },
      component: (resolve) => require(['@/content/ai/detail'], resolve)
    },
    // 浏览器黑名单
    {
      path: '/ua-deny',
      name: 'ua-deny',
      component: (resolve) => require(['@/content/UaDeny.vue'], resolve)
    },
    {
      path: '/ua-deny-exam',
      name: 'ua-deny-exam',
      component: (resolve) => require(['@/content/UaDenyExam.vue'], resolve)
    },
    // AI面试
    {
      path: "/ai-main",
      redirect: "/app/ai-main"
    },
    {
        path: '/app/ai-main',
        name: 'ai-main',
        component: (resolve) => require(['@/content/ai-interview/main'], resolve)
    }, {
        path: '/ai-join',
        name: 'ai-join',
        component: (resolve) => require(['@/content/ai-interview/join'], resolve)
    }, {
        path: '/ai-content',
        name: 'ai-content',
        component: (resolve) => require(['@/content/ai-interview/content'], resolve)
    }, {
        path: '/ai-finish',
        name: 'ai-finish',
        component: (resolve) => require(['@/content/ai-interview/finish'], resolve)
    },
    // 群面
    ...GroupInterviewRoutes,
    {
      path: "/code-error",
      name: "code-error",
      component: ()=> import("@/components/CodeError.vue")
    },
    {
      path: "/select-company",
      name: "select-company",
      component: () => import("@/content/auth/selectCompany.vue")
    },
    {
      path: "/405",
      name: "405",
      component: ()=>import("@/content/error/noAuth.vue")
    },
    {
      path: "/404",
      name: "404",
      component: ()=>import("@/content/error.vue")
    },
    {
      path: "*",
      name: "not-found",
      component: ()=>import("@/content/error.vue")
    }
  ],
})
router.beforeEach((to, from, next) => {
  to.meta.originUrl = location.href
  if(_.startsWith(to.fullPath, '/#/')){
    next(to.fullPath.substring(2, to.fullPath.length))
    return
  }
  // 浏览器校验
  if (to.meta.checkUa) {
      toolkit.checkUa(to.path, to.fullPath).then(() => {
          authValidate(to, from, next)
      }).catch((e) => {
          next({
            name:'ua-deny',
            query:{
              url:to.fullPath
            }
          })
      })
  }
  else if(to.meta.checkExamUa){ // 在线笔试浏览器校验
      toolkit.checkExamUa().then(() => {
          authValidate(to, from, next)
      }).catch(() => {
          next('/ua-deny-exam')
      })
  }
  else {
      authValidate(to, from, next)
  }
})

function authValidate(to, from, next) {
    // 登录检验
    if (to.meta.needToken) {
        let token = toolkit.getToken()
        if (token && token !== 'null') {
            toolkit.getUserInfo().then(res => { // 拿到token
              if(to.meta.needCompany){
                toolkit.getCompanyInfo().then(() => {
                  next()
                })
              }else{
                next()
              }
            }).catch(err => {
                next({
                    name: 'login',
                    query: to.query
                })
            })
        } else {
            next({
                name: 'login',
                query: to.query
            })
        }
    } else {
        next()
    }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js